<template>
    <div v-if="isShow" :style="domStyle" style="paddingTop: 4px;">
        <div v-for="(val, key) in menuList" :key="key"  :style="menu_content" @click="selectNav(val.name,key)">
            <div class="menu_list" :class="isSelect == val.name ? 'active' : 'across'">
                <img class="appFootImg" :src="val.icon" :width="20" :height="20">
                <span class="appFootText">{{val.name}}</span>
            </div>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.parentObject.width + "px",
            height : this.parentObject.height + "px",
            display : "flex",
            alignItems : "center",
            backgroundColor: '#1D3352'
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(this.OnClick && this.OnClick != "%OnClick%"){
            this.OnClick = AsyncFunction("index",this.OnClick);
        };
        this.isSelect = this.menuList[0].name;
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            isSelect : "",
            // 版本号
            version: "10.0.3.1"
        }
    },
    computed: {
        menu_content(){
            return {
                width : Number(100 / this.menuList.length) + "%",
                height: 100 + "%",
                alignItems : "center",
                display: 'inline-block',
            }
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.$el.style.width = parseInt(this.parentObject.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = this.parentObject.height * scaleObj.sy + "px";
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数： name 点击的标识，key 下标
            作用：触发底部菜单的脚本事件
        */
        selectNav(name,key){
            //需要执行的事件
            this.isSelect = name;
            var index = Number(key + 1);
            if(typeof this.OnClick == "function"){
                this.fvSystemApi.executionScript(this.OnClick,index);
            };
        }
    }
}
</script>

<style>
    .active{
        color : #fff;
    }
    .across{
        color : '#000';
    }
    .across:hover{
        color : #fff;
    }
    .menu_list{
        width : 100%;
        height: 100%;
        display:flex;
        justify-content : center;
        float : left;
        align-items : center;
        flex-direction : column;
        cursor : pointer;
    }
    .appFootText {
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvAppFooter/fvAppFooter.vue